import { DOC_SECTIONS } from "../features/docs/content";
import { DocSection } from "../features/docs/DocSection";

export const DocsPage = () => (
	<div className="space-y-6">
		<div>
			<h2 className="text-xl font-semibold tracking-tight text-ink">Docs and guides</h2>
			<p className="mt-1 text-sm text-ink-muted">
				How campaigns work and what to switch on in your theme.
			</p>
		</div>

		<div className="grid gap-6 lg:grid-cols-[13rem_1fr]">
			<nav className="lg:sticky lg:top-6 lg:self-start">
				<ul className="space-y-1">
					{DOC_SECTIONS.map((section) => (
						<li key={section.id}>
							<a
								href={`#${section.id}`}
								className="block rounded-md px-2 py-1.5 text-sm text-ink-muted transition-colors hover:bg-raised hover:text-ink"
							>
								{section.title}
							</a>
						</li>
					))}
				</ul>
			</nav>

			<div className="min-w-0 space-y-4">
				{DOC_SECTIONS.map((section) => (
					<DocSection key={section.id} section={section} />
				))}
			</div>
		</div>
	</div>
);
